import { create } from 'zustand';

const KEY = 'wikiPendingQuote';

export interface WikiQuote {
  text: string;
  title: string;
  href: string;
}

interface QuoteState {
  quote: WikiQuote | null;
  setQuote: (quote: WikiQuote) => void;
  clearQuote: () => void;
}

function restore(): WikiQuote | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as WikiQuote) : null;
  } catch {
    return null;
  }
}

function persist(quote: WikiQuote | null): void {
  if (typeof window === 'undefined') return;
  if (quote) window.sessionStorage.setItem(KEY, JSON.stringify(quote));
  else window.sessionStorage.removeItem(KEY);
}

export const useQuoteStore = create<QuoteState>((set) => ({
  quote: restore(),
  setQuote: (quote) => {
    persist(quote);
    set({ quote });
  },
  clearQuote: () => {
    persist(null);
    set({ quote: null });
  },
}));

export function formatQuote(quote: WikiQuote, origin = window.location.origin): string {
  const lines = quote.text
    .trim()
    .split('\n')
    .map((line) => `> ${line}`)
    .join('\n');
  return `${lines}\nИнструкция «${quote.title}»: ${origin}${quote.href}\n`;
}
